import { fmtDate } from "../../lib/plan";
import { dosesFor } from "../../lib/irrigation";
import { NAME, ml } from "./cq";

const WeekCard = ({ w, current, active, focus, onPick }) => {
  const all = dosesFor(w.col);
  const doses = focus ? all.filter((d) => focus.includes(d.id)) : all;
  const waters = w.days.filter((d) => d.water).length;
  return (
    <button type="button" onClick={onPick} data-testid={`cq-week-${w.n}`} aria-current={current ? "true" : undefined}
      className={`w-full text-left rounded-[18px] p-4 border-2 transition-[background-color,border-color] ${
        active ? "bg-[#1E7A3C] border-white" : current ? "bg-[#1E7A3C]/80 border-[#F2B441]" : "bg-[#0F3D1E]/85 border-[#8CD05A]/25"}`}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="font-label text-lg text-white">S{w.n} · {w.col}</span>
        <span className="font-mono-d text-xs text-[#E6F2DF]">{fmtDate(w.days[0].date)} – {fmtDate(w.days[6].date)}</span>
      </div>
      <p className="text-sm text-[#E6F2DF] mt-0.5">{w.label} · {waters} riegos{current ? " · esta semana" : ""}</p>
      {doses.length ? (
        <ul className="mt-3 grid grid-cols-2 gap-1.5">
          {doses.map((d) => (
            <li key={d.id} className="rounded-[10px] bg-black/25 px-2.5 py-1.5 flex justify-between gap-2 text-sm">
              <span className="text-white">{NAME[d.id]}</span><span className="font-mono-d text-white font-medium whitespace-nowrap">{ml(d.dose)}</span>
            </li>
          ))}
        </ul>
      ) : <p className="mt-3 text-sm text-white">{all.length ? "No lleva este producto" : "Solo agua (lavado)"}</p>}
    </button>
  );
};

export const CqTable = ({ weeks, current, active, focus, onPick }) => (
  <section data-testid="cq-table" aria-label="Cuadrante completo" className="mt-8">
    <h2 className="font-serif-d font-black text-2xl text-white mb-1">Cuadrante completo · 100 L</h2>
    <p className="text-sm text-[#E6F2DF] mb-4">Misma dosis en cada riego de la semana. Toca una semana para ver sus días.</p>
    <div className="space-y-2.5">
      {weeks.map((w, i) => <WeekCard key={w.n} w={w} current={i === current} active={i === active} focus={focus} onPick={() => onPick(i)} />)}
    </div>
  </section>
);
